import { queryOptions, useQuery } from '@tanstack/react-query'
import { localizeContentTitle } from '~/lib/content-title'

/** One cached lookup per title key, shared by every place naming a reward. */
export function contentTitleQueryOptions(key: string | null) {
  return queryOptions({
    queryKey: ['content-title', key],
    queryFn: () => localizeContentTitle(key),
    enabled: !!key,
  })
}

/**
 * A content title from the native string catalog. Empty until resolved and
 * on a miss.
 */
export function useContentTitle(key: string | null): string {
  return useQuery(contentTitleQueryOptions(key)).data ?? ''
}
